<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "Rule Profile Config" }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the current rule Profile config." }}
      </p>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <tabs v-model="defactiveIndex">
          <pane label="Rule Config">
            <block-cntr :btitle="'Rule Profile Config'" style="height: 410px">
              <div class="form-inline">
                <span style="float: left">
                  <div class="btn-group open">
                    <div
                      @click="isShowAddTable = true"
                      class="btn"
                      :class="{ disabled: false }"
                      style="padding: 0px"
                    >
                      <i class="fa fa-plus page-tableaction"></i>
                    </div>
                    <div
                      @click="clkEdit()"
                      class="btn"
                      :class="{ disabled: false }"
                      style="padding: 0px"
                    >
                      <i class="fa fa-edit page-tableaction"></i>
                    </div>
                    <div
                      @click="clkDel()"
                      class="btn"
                      :class="{ disabled: false }"
                      style="padding: 0px"
                    >
                      <i class="fa fa-trash-o page-tableaction"></i>
                    </div>
                  </div>
                </span>
                <label style="float: right; display: flex">
                  <span class="input-group-addon tablesearch-box">
                    <i class="fa fa-search"></i>
                  </span>
                  <input
                    type="search"
                    v-model="searchText"
                    class="form-control"
                    placeholder="search with profile id.."
                    style="border-radius: 0px"
                  />
                </label>
              </div>

              <table class="table table-hover table-noneborder-top">
                <thead>
                  <tr>
                    <th width="40px">
                      <input
                        type="checkbox"
                        v-model="isSelectAll"
                        @change="changeSelectAll()"
                        id="idSelectAll"
                      />
                      <label for="idSelectAll"></label>
                    </th>
                    <th
                      v-for="(value, key) in title"
                      :key="key"
                      :title="value"
                    >
                      {{ value }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(row, index) in ruleTableFilter"
                    :key="index"
                    :class="{ 'true:': true }"
                    @click="changeSelect(row)"
                  >
                    <td width="40px">
                      <div @click.stop="" v-if="!row.isNew">
                        <input
                          type="checkbox"
                          v-model="row.selected"
                          :id="'idRowSelect' + index"
                        />
                        <label :for="'idRowSelect' + index"></label>
                      </div>
                    </td>
                    <td>
                      <div>{{ row.profileId }}</div>
                    </td>
                    <td>
                      <div>{{ row.profileName }}</div>
                    </td>
                    <td>
                      <div>{{ row.authMode | capitalize }}</div>
                    </td>
                    <td>
                      <div>{{ row.snLoid }}</div>
                    </td>
                    <td>
                      <div>{{ row.snLoidPw }}</div>
                    </td>
                    <td>
                      <div>{{ row.lineList }}</div>
                    </td>
                    <td>
                      <div>{{ row.defLine }}</div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div v-if="isShowAddTable">
                <dialog-box
                  :btitle="'Rule Profile Edit'"
                  @close="clkCancel()"
                  :scroll="true"
                >
                  <form class="form-horizontal" role="form">
                    <div class="form-group">
                      <label class="col-sm-3 control-label" for="profileId">{{
                        title.profileId
                      }}</label>
                      <div
                        class="col-sm-5"
                        :class="{ 'has-error': input_para_check(1) }"
                      >
                        <input
                          type="text"
                          class="form-control"
                          id="profileId"
                          autocomplete="off"
                          :disabled="isEditClik"
                          v-model="ruleForm.profileId"
                          placeholder="STRING<5-8>:slot/pon/ont"
                        />
                        <small
                          class="help-block"
                          :style="{
                            display: input_para_check(1) ? 'block' : 'none',
                          }"
                          >{{ input_para_check(1) }}
                        </small>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-sm-3 control-label" for="name">{{
                        title.profileName
                      }}</label>
                      <div
                        class="col-sm-5"
                        :class="{ 'has-error': input_para_check(4) }"
                      >
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          maxlength="128"
                          autocomplete="off"
                          v-model="ruleForm.profileName"
                          placeholder="STRING<1-128>"
                        />
                        <small
                          class="help-block"
                          :style="{
                            display: input_para_check(4) ? 'block' : 'none',
                          }"
                          >{{ input_para_check(4) }}
                        </small>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-sm-3 control-label" for="mode">{{
                        title.authMode
                      }}</label>
                      <div class="col-sm-5">
                        <select
                          class="form-control"
                          id="mode"
                          v-model="ruleForm.authMode"
                        >
                          <option
                            value=""
                            disabled
                            selected
                            style="display: none"
                          >
                            please choose..
                          </option>
                          <option value="0">Sn</option>
                          <option value="1">Pw</option>
                          <option value="2">Sn+Pw</option>
                          <option value="3">Loid</option>
                          <option value="4">LoidPw</option>
                          <option value="5">Loid+LoidPw</option>
                        </select>
                      </div>
                    </div>

                    <div
                      v-if="
                        ruleForm.authMode == '3' || ruleForm.authMode == '5'
                      "
                      class="form-group"
                    >
                      <label class="col-sm-3 control-label" for="loid"
                        >Loid</label
                      >
                      <div
                        class="col-sm-5"
                        :class="{ 'has-error': input_para_check(5) }"
                      >
                        <input
                          type="text"
                          class="form-control"
                          id="loid"
                          v-model="ruleForm.loid"
                          maxlength="24"
                          placeholder="STRING<1-24>"
                        />
                        <small
                          class="help-block"
                          :style="{
                            display: input_para_check(5) ? 'block' : 'none',
                          }"
                          >{{ input_para_check(5) }}
                        </small>
                      </div>
                    </div>
                    <div
                      v-if="
                        ruleForm.authMode == '4' || ruleForm.authMode == '5'
                      "
                      class="form-group"
                    >
                      <label class="col-sm-3 control-label" for="loidpw"
                        >LoidPw</label
                      >
                      <div
                        class="col-sm-5"
                        :class="{ 'has-error': input_para_check(6) }"
                      >
                        <input
                          type="text"
                          class="form-control"
                          id="loidpw"
                          v-model="ruleForm.loidPw"
                          maxlength="12"
                          placeholder="STRING<1-12>"
                        />
                        <small
                          class="help-block"
                          :style="{
                            display: input_para_check(6) ? 'block' : 'none',
                          }"
                          >{{ input_para_check(6) }}
                        </small>
                      </div>
                    </div>
                    <div
                      v-if="
                        ruleForm.authMode == '0' || ruleForm.authMode == '2'
                      "
                      class="form-group"
                    >
                      <label class="col-sm-3 control-label"></label>
                      <div class="col-sm-5">
                        <label>
                          <input
                            type="radio"
                            class="form-control"
                            value="0"
                            id="snstring-hex"
                            v-model="ruleForm.snFormat"
                          />
                          <label for="snstring-hex">string-hex</label>
                        </label>
                        <label style="margin-left: 15px">
                          <input
                            type="radio"
                            class="form-control"
                            value="1"
                            id="snhex"
                            v-model="ruleForm.snFormat"
                          />
                          <label for="snhex">hex</label>
                        </label>
                      </div>
                    </div>
                    <div
                      v-if="
                        ruleForm.authMode == '0' || ruleForm.authMode == '2'
                      "
                      class="form-group"
                    >
                      <label class="col-sm-3 control-label" for="sn">Sn</label>
                      <div
                        class="col-sm-5"
                        :class="{ 'has-error': input_para_check(2) }"
                      >
                        <input
                          type="text"
                          class="form-control"
                          id="sn"
                          v-model="ruleForm.sn"
                          maxlength="16"
                          placeholder="STRING<13-16>"
                        />
                        <small
                          class="help-block"
                          :style="{
                            display: input_para_check(2) ? 'block' : 'none',
                          }"
                          >{{ input_para_check(2) }}
                        </small>
                      </div>
                    </div>

                    <div
                      v-if="
                        ruleForm.authMode == '1' || ruleForm.authMode == '2'
                      "
                      class="form-group"
                    >
                      <label class="col-sm-3 control-label"></label>
                      <div class="col-sm-5">
                        <label>
                          <input
                            type="radio"
                            class="form-control"
                            value="0"
                            id="pwstring-hex"
                            v-model="ruleForm.pwFormat"
                          />
                          <label for="pwstring-hex">string</label>
                        </label>
                        <label style="margin-left: 15px">
                          <input
                            type="radio"
                            class="form-control"
                            value="1"
                            id="pwhex"
                            v-model="ruleForm.pwFormat"
                          />
                          <label for="pwhex">hex</label>
                        </label>
                      </div>
                    </div>

                    <div
                      v-if="
                        ruleForm.authMode == '1' || ruleForm.authMode == '2'
                      "
                      class="form-group"
                    >
                      <label class="col-sm-3 control-label" for="snpw"
                        >Pw</label
                      >
                      <div
                        class="col-sm-5"
                        :class="{ 'has-error': input_para_check(3) }"
                      >
                        <input
                          type="text"
                          class="form-control"
                          id="snpw"
                          maxlength="20"
                          v-model="ruleForm.snPw"
                          placeholder="STRING<1-20>"
                        />
                        <small
                          class="help-block"
                          :style="{
                            display: input_para_check(3) ? 'block' : 'none',
                          }"
                          >{{ input_para_check(3) }}
                        </small>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-3 control-label" for="linelist">{{
                        title.lineList
                      }}</label>
                      <div class="col-sm-5">
                        <select
                          name="linelist"
                          class="form-control"
                          id="linelist"
                          v-model="ruleForm.lineList"
                        >
                          <option value="">None</option>
                          <option
                            v-for="(line, index) in lineTable"
                            :key="index"
                            :value="line.profileId"
                          >
                            {{ line.profileId + ":" + line.profileName }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-3 control-label" for="defline">{{
                        title.defLine
                      }}</label>
                      <div class="col-sm-5">
                        <select
                          name="defline"
                          class="form-control"
                          id="defline"
                          v-model="ruleForm.defLine"
                        >
                          <option value="">None</option>
                          <option
                            v-for="(line, index) in lineTable"
                            :key="index"
                            :value="line.profileId"
                          >
                            {{ line.profileId + ":" + line.profileName }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <button
                      type="button"
                      class="btn btn-primary"
                      style="
                        margin-left: 20%;
                        min-width: 77px;
                        color: #fff;
                        background-color: #008b8b;
                        border-color: #008080;
                      "
                      @click="clkApply()"
                    >
                      {{ "Apply" }}
                    </button>
                    <span style="margin-left: 10px">
                      <button
                        type="button"
                        class="btn btn-default"
                        style="min-width: 77px"
                        @click="clkCancel()"
                      >
                        {{ "Cancel" }}
                      </button>
                    </span>
                  </form>
                </dialog-box>
              </div>
            </block-cntr>
          </pane>
          <pane label="Rule statistics">
            <block-cntr
              :btitle="'Rule Profile statistics'"
              style="height: 410px"
            >
              <div class="form-inline" style="height: 35px">
                <span style="float: left">
                  <div class="btn-group open">
                    <div
                      @click="loadRuleProfileBrief()"
                      class="btn"
                      :class="{}"
                      style="padding: 0px"
                    >
                      <i class="fa fa-refresh page-tableaction"></i>
                    </div>
                  </div>
                </span>
              </div>
              <table class="table table-hover table-noneborder-top">
                <thead>
                  <tr>
                    <th
                      v-for="(value, key) in ruleBriefTable.title"
                      :key="key"
                      :title="value"
                    >
                      {{ value }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(row, index) in ruleBriefTable.data"
                    :key="index"
                    :class="{ 'true:': true }"
                  >
                    <td v-for="(value, key) in row" :key="key">
                      <div>{{ value }}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </block-cntr>
          </pane>
        </tabs>
      </div>
    </div>
    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>


<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"
import InfoBox from "./../components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import SelectInput from "@/components/SelectInput.vue"
import Pane from "./../components/Pane.vue"
import Tabs from "./../components/Tabs.vue"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "profileRule",
  components: {
    BlockCntr,
    DialogBox,
    InfoBox,
    Pane,
    Tabs,
  },

  data() {
    return {
      title: {},
      isShowAddTable: this.$route.query.edit ? this.$route.query.edit : false,
      isEditClik: false,
      isSelectAll: false,
      defactiveIndex: 0,
      isInitValue: this.$route.query.edit ? this.$route.query.edit : false,
      iBox: {},
      searchText: "",
      select: [],
      lineList: [],
      ruleForm: {
        profileId: this.$route.query.port ? this.$route.query.port.replace('g','') : "",
        profileName: "",
        authMode: this.$route.query.authmode ? this.$route.query.authmode : "",
        loid:  this.$route.query.loid ? this.$route.query.loid : "",
        loidPw: this.$route.query.loidpw ? this.$route.query.loidpw : "",
        sn: this.$route.query.sn ? this.$route.query.sn : "",
        snPw: this.$route.query.pw ? this.$route.query.pw : "",
        lineList: "",
        defLine: "",
        snFormat: this.$route.query.snFormat ? this.$route.query.snFormat : 0,
        pwFormat: this.$route.query.pwFormat ? this.$route.query.pwFormat : 0,
      },

      ruleTable: [],
      ruleTableCalc: [],

      ruleBriefTable: [],

      lineTable: [],
    }
  },

  created() {
    this.loadRuleProfile()
    this.loadRuleProfileBrief()
    this.loadLineProfilePri()
  },

  computed: {
    ruleTableFilter() {
      this.ruleTableCalc = []
      if (this.ruleTable !== undefined)
        this.ruleTable.forEach((element) => {
          for (const key in element) {
            if (
              this.searchText === "" ||
              (typeof element[key] === "string" &&
                element[key].indexOf(this.searchText) !== -1)
            ) {
              this.ruleTableCalc.push(element)
              break
            }
          }
        })
      return this.ruleTableCalc
    },
  },

  watch: {
    "ruleForm.authMode": function (newval, oldval) {
      if(!this.isInitValue)
      {
        if (oldval != "") {
        this.ruleForm.loid = ""
        this.ruleForm.loidPw = ""
        this.ruleForm.sn = ""
        this.ruleForm.snPw = ""
        }
      }
    },
  },

  methods: {
    loadRuleProfile() {
      get("profilerule")
        .then((res) => {
          this.ruleTable = res.data.data
          this.title = res.data.title
        })
        .catch((err) => {
          console.log(err)
        })
    },

    loadLineProfilePri() {
      get("profilelinepri")
        .then((res) => {
          this.lineTable = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    loadRuleProfileBrief() {
      get("profilerulebrief")
        .then((res) => {
          console.log(res.data)
          this.ruleBriefTable = res.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    resetField() {
      var dbaformTmp = {
        profileId: "",
        profileName: "",
        authMode: "",
        loid: "",
        loidPw: "",
        sn: "",
        snPw: "",
        lineList: "",
        defLine: "",
        snFormat: 0,
        pwFormat: 0,
      }

      this.ruleForm = dbaformTmp
      this.isInitValue = false
      this.lineList.forEach((element) => {
        element.Check = false
      })
    },

    profileSortFun(a, b) {
      var str = a.profileId.split("/")
      var str1 = b.profileId.split("/")
      var onu = Number(str[0]) * 16 + Number(str[1]) * 64 + Number(str[2])
      var onu1 = Number(str[0]) * 16 + Number(str[1]) * 64 + Number(str[2])
      return onu - onu1
    },

    clkApply() {
      var newProfile = {
        profileId: this.ruleForm.profileId,
        profileName: this.ruleForm.profileName,
        authMode: Number(this.ruleForm.authMode),
        sn: this.ruleForm.sn,
        snPw: this.ruleForm.snPw,
        loid: this.ruleForm.loid,
        loidPw: this.ruleForm.loidPw,
        lineList: this.ruleForm.lineList,
        defLine: Number(this.ruleForm.defLine),
        snFormat: Number(this.ruleForm.snFormat),
        pwFormat: Number(this.ruleForm.pwFormat),
        operate: 1,
      }

      var newProfile1 = {
        profileId: this.ruleForm.profileId,
        profileName: this.ruleForm.profileName,
        authMode: Number(this.ruleForm.authMode),
        snLoid: this.ruleForm.sn,
        snLoidPw: this.ruleForm.snPw,
        lineList: this.ruleForm.lineList,
        defLine: this.ruleForm.defLine,
      }

      console.log(this.ruleForm.lineList)
      var msg = this.input_para_check(0)
      if (msg != null) {
        this.showAlertBox("warn", "Message", msg)
        return
      }

      if (this.ruleForm.defLine == "") newProfile.defLine = -1

      if (this.ruleForm.authMode > "2") {
        newProfile1.snLoid = this.ruleForm.loid
        newProfile1.snLoidPw = this.ruleForm.loidPw
      }

      if (!this.isEditClik) {
        for (let i = 0; i < this.ruleTable.length; i++) {
          if (this.ruleTable[i].profileId == newProfile.profileId) {
            this.showAlertBox(
              "warn",
              "Message",
              "this profile id has been existed,please choose a new one"
            )
            return
          }
        }
      }

      post("profilerule", newProfile)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")
            this.loadRuleProfile()
            /*if (this.isEditClik) {
              let index = this.select[0]
              this.ruleTable[index] = newProfile
            }else{
              this.ruleTable.push(newProfile1)
              this.ruleTable.sort(this.profileSortFun)
            }*/
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    clkEdit() {
      for (let i = 0; i < this.ruleTableCalc.length; i++) {
        if (this.ruleTableCalc[i].selected) {
          this.ruleForm.profileId = this.ruleTableCalc[i].profileId
          if (this.ruleTableCalc[i].profileName.match(/^INDEX_/) == null) {
            this.ruleForm.profileName = this.ruleTableCalc[i].profileName
          }

          this.ruleForm.authMode = this.ruleTableCalc[i].authMode

          if (this.ruleTableCalc[i].authMode < 3) {
            this.ruleForm.sn = this.ruleTableCalc[i].snLoid.replace("0x", "")
            this.ruleForm.snPw = this.ruleTableCalc[i].snLoidPw.replace(
              "0x",
              ""
            )
            if (this.ruleTableCalc[i].snLoid.match(/^0x/) != null)
              this.ruleForm.snFormat = 1
            if (this.ruleTableCalc[i].snLoidPw.match(/^0x/) != null)
              this.ruleForm.pwFormat = 1
          } else {
            this.ruleForm.loid = this.ruleTableCalc[i].snLoid
            this.ruleForm.loidPw = this.ruleTableCalc[i].snLoidPw
          }

          this.ruleForm.defLine = this.ruleTableCalc[i].defLine
          this.ruleForm.lineList = this.ruleTableCalc[i].lineList

          this.isShowAddTable = true
          this.isEditClik = true
          this.select[0] = i
          return
        }
      }
    },

    clkDel() {
      var errflag = 0
      var del = []
      var i
      var id = []
      var newProfile = {
        profileId: "",
        operate: 2,
      }

      for (i = 0; i < this.ruleTableCalc.length; i++) {
        if (this.ruleTableCalc[i].selected) {
          newProfile.profileId = this.ruleTableCalc[i].profileId
          del.push(post("profilerule", newProfile))
          id.push(this.ruleTableCalc[i].profileId)
        }
      }

      if (del.length == 0) {
        return
      }

      Promise.all(del)
        .then((res) => {
          res.forEach((element, index) => {
            if (
              element.data == undefined ||
              element.data.code === undefined ||
              element.data.code === 0
            ) {
              for (i = 0; i < this.ruleTable.length; i++) {
                if (this.ruleTable[i].profileId == id[index]) {
                  this.ruleTable.splice(i, 1)
                  break
                }
              }
            } else {
              this.showAlertBox("warn", "Message", element.data.msg)
              errflag = 1
            }
          })
          if (errflag === 0)
            this.showAlertBox("info", "Info", "Delete successful!")
        })

        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    changeSelectAll() {
      for (let i = 0; i < this.ruleTableCalc.length; i++) {
        if (this.isSelectAll) {
          this.$set(this.ruleTableCalc[i], "selected", true)
        } else {
          this.$set(this.ruleTableCalc[i], "selected", false)
        }
      }
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },

    changeSelect(row) {
      console.log(row)
      if (row.selected == undefined) {
        this.$set(row, "selected", true)
      } else row.selected = !row.selected
    },

    input_para_check(value) {
      if (value == 1 || value == 0) {
        if (this.ruleForm.profileId != "") {
          if (
            this.ruleForm.profileId.match(
              /0\/[1-9][0-9]?\/[1-9][0-9]?[0-9]?$/
            ) == null
          ) {
            return "id must be inputted with slot<0-0>/pon<1-16>/ont<1-128> "
          } else {
            var id = this.ruleForm.profileId.split("/")
            let slot = Number(id[0])
            let port = Number(id[1])
            let ont = Number(id[2])
            if (slot != 0 || port > 16 || ont > 128)
              return "id must be inputted with slot<0-0>/pon<1-16>/ont<1-128> "
          }
        }
      }

      if (value == 2 || value == 0) {
        if (this.ruleForm.sn != "") {
          if (this.ruleForm.snFormat == "0") {
            if (this.ruleForm.sn.match(/^[\S]{4}-[0-9a-fA-F]{8}$/) == null) {
              return "sn format must be CHAR(4)-HEX(8):XXXX-XXXXXXXX"
            }
          } else {
            if (this.ruleForm.sn.match(/^[0-9a-fA-F]{16}$/) == null) {
              return "sn format must be HEX(16)"
            }
          }
        }
      }

      if (value == 3 || value == 0) {
        if (this.ruleForm.snPw != "") {
          if (this.ruleForm.pwFormat == "0") {
            if (
              this.ruleForm.snPw.match(/^(?=[\u0020-\u007e]+$)[\S]{1,10}$/) ==
              null
            ) {
              return "snPw format must be CHAR(1-10)"
            }
          } else {
            if (this.ruleForm.snPw.match(/^[0-9a-fA-F]{1,20}$/) == null) {
              return "snPw format must be HEX(1-20)"
            }
          }
        }
      }

      if (value == 4 || value == 0) {
        var space=/[\s]/
        if (space.test(this.ruleForm.profileName)) return "Contains illegal characters."
        else
          return nonASCIIchar(this.ruleForm.profileName)
      }

      if (value == 5 || value == 0) {
        if (this.ruleForm.loid != "") {
          if (
            this.ruleForm.loid.match(/^(?=[\u0020-\u007e]+$)[\S]{1,24}$/) ==
            null
          ) {
            return "Loid contains invalid character"
          }
        }
      }

      if (value == 6 || value == 0) {
        if (this.ruleForm.loidPw != "") {
          if (
            this.ruleForm.loidPw.match(/^(?=[\u0020-\u007e]+$)[\S]{1,12}$/) ==
            null
          ) {
            return "LoidPw contains invalid character"
          }
        }
      }

      return null
    },
  },

  filters: {
    capitalize: function (value) {
      if (value == "0") return "Sn"
      else if (value == "1") return "Pw"
      else if (value == "2") return "Sn+Pw"
      else if (value == "3") return "Loid"
      else if (value == "4") return "LoidPw"
      else if (value == "5") return "Loid+LoidPw"
      else return value
    },
  },
}
</script>

<style>
</style>